<template>
  <div class="app-wrapper d-flex flex-column min-vh-100 bg-light">
    <HeaderComponent />

    <div class="container">
      <h1>Koemans Vastgoed</h1>
      <p>Den Haag en omstreken</p>
    </div>

    <GalleryComponent />

    <div class="container">
      <div class="row">
        <div class="col-lg-8 mb-3">
          <InfoComponent />
          <DatepickerComponent />
        </div>

        <div class="col-lg-4">
          <FloatingComponent />
        </div>
      </div>
    </div>

    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import InfoComponent from "@/components/InfoComponent.vue";
import FloatingComponent from "@/components/FloatingComponent.vue";
export default {
  components: {
    FooterComponent,
    HeaderComponent,
    InfoComponent,
    FloatingComponent,
  },
};
</script>

<style scoped>
/* Ensure the video container has a max height of 600px */
.video-container {
  position: relative;
  width: 100%;
  height: 60vh;
  overflow: hidden;
}

.video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Additional styling for the container and card */
.container {
  margin-top: 20px; /* Adjust margin as needed */
}

.villa-header {
  background-color: #f8f9fa;
  padding: 20px;
}

.villa-images img {
  width: 100%;
  height: auto;
  border-radius: 10px;
}

.villa-info {
  padding: 20px;
}

.chat-widget {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.chat-widget img {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}

/* Contact section styling */
.contact-section h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.contact-section a {
  color: #007bff;
  text-decoration: none;
}

.contact-section a:hover {
  text-decoration: underline;
}
</style>
